
import React from "react";
import { Box } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useTranslation } from "react-i18next";
import TestCard from "./TestCard";
import FavoriteButton from "@/components/common/FavoriteButton";

interface Test {
  id: string;
  title: string;
  description: string;
  icon: string;
}

interface BunkerTestsSectionProps {
  bunkerTests: Test[];
  onSelectTest: (testId: string) => void;
}

const BunkerTestsSection: React.FC<BunkerTestsSectionProps> = ({ 
  bunkerTests, 
  onSelectTest 
}) => {
  const { t } = useTranslation('training');
  
  return (
    <Card className="border-2 border-golf-600 mb-8">
      <CardHeader className="bg-golf-50">
        <div className="flex items-center gap-2">
          <Box className="h-6 w-6 text-golf-700" />
          <CardTitle className="text-xl text-golf-800">{t('level3.testSections.bunker.title')}</CardTitle>
        </div>
        <CardDescription className="text-golf-600">
          {t('level3.testSections.bunker.description')}
        </CardDescription>
      </CardHeader>
      <CardContent className="p-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {bunkerTests.map((test) => (
            <TestCard
              key={test.id}
              id={test.id}
              title={test.title}
              description={test.description}
              icon={test.icon}
              onSelectTest={onSelectTest}
              favoriteButton={
                <FavoriteButton 
                  testId={test.id} 
                  testType="level3"
                  size="icon"
                  variant="ghost"
                />
              }
            />
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default BunkerTestsSection;
